export default __webpack_public_path__ + "static/media/img_card_3.e45f67c8.svg";